import { CLOUDINARY_CLOUD_NAME, CLOUDINARY_UPLOAD_PRESET } from '@env';

/** Galeri / web dosya seçiminden sonra yükleme kaynağı */
export type PickedListingMedia = {
  uri: string;
  /** Web: doğrudan multipart için */
  webFile?: File;
  type?: string;
  fileName?: string;
};

export function assertCloudinaryConfigured(): void {
  const c = (CLOUDINARY_CLOUD_NAME ?? '').trim();
  const p = (CLOUDINARY_UPLOAD_PRESET ?? '').trim();
  if (!c || !p) {
    throw new Error(
      'Cloudinary yapılandırılmamış. Proje kökünde .env dosyasına CLOUDINARY_CLOUD_NAME ve CLOUDINARY_UPLOAD_PRESET ekleyin (.env.example).',
    );
  }
}

/**
 * Unsigned upload (upload preset). Güvenlik: preset’i Cloudinary’de yalnızca yükleme + klasör kısıtı ile tanımlayın.
 */
export async function uploadImageToCloudinary(media: PickedListingMedia): Promise<string> {
  assertCloudinaryConfigured();
  const cn = (CLOUDINARY_CLOUD_NAME ?? '').trim();
  const preset = (CLOUDINARY_UPLOAD_PRESET ?? '').trim();

  const form = new FormData();
  if (media.webFile) {
    form.append('file', media.webFile);
  } else {
    const name = media.fileName?.trim() || 'upload.jpg';
    const type = media.type?.trim() || 'image/jpeg';
    form.append('file', {
      uri: media.uri,
      type,
      name,
    } as unknown as Blob);
  }
  form.append('upload_preset', preset);

  const res = await fetch(`https://api.cloudinary.com/v1_1/${cn}/image/upload`, {
    method: 'POST',
    body: form,
  });
  const json = (await res.json()) as { secure_url?: string; error?: { message?: string } };
  if (!res.ok) {
    throw new Error(json.error?.message || `Cloudinary yükleme hatası (${res.status})`);
  }
  const url = json.secure_url;
  if (!url) {
    throw new Error('Cloudinary yanıtında URL yok.');
  }
  return url;
}

/** Kart önizlemesi için otomatik optimizasyon (genişlik + kalite). */
export function cloudinaryDisplayUrl(originalUrl: string, width = 500): string {
  if (!originalUrl?.includes('res.cloudinary.com') || !originalUrl.includes('/upload/')) {
    return originalUrl;
  }
  const parts = originalUrl.split('/upload/');
  if (parts.length < 2) {
    return originalUrl;
  }
  const rest = parts[1]!;
  if (/^(w_|c_|q_|f_|h_|ar_)/.test(rest) || rest.includes(',w_')) {
    return originalUrl;
  }
  return `${parts[0]}/upload/w_${width},q_auto,f_auto/${rest}`;
}

export async function uploadListingImages(mediaList: PickedListingMedia[]): Promise<string[]> {
  const out: string[] = [];
  for (const m of mediaList) {
    out.push(await uploadImageToCloudinary(m));
  }
  return out;
}
